import React from 'react';
import Ellipse74 from '../../../Assets/Images/ellipse_74.svg';
import Ellipse75 from '../../../Assets/Images/ellipse_75.svg';
import ErrorPage404 from '../../../Assets/Images/404_error_page.svg';
import PrimaryButton from '../../Common/Button/PrimaryButton';

const ErrorBoundarypage = () => {
  return (
    <div style={{ height: '100vh', width: '100vw', backgroundColor: '#EAF2E5' }}>
      <div style={{ maxWidth: '100%', height: 'auto', position: 'absolute', right: 0 }}>
        <img src={Ellipse74} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          zIndex: 10,
          position: 'relative'
        }}
      >
        <div>
          <img src={ErrorPage404} style={{ maxWidth: '100%', height: 'auto' }} alt='Error Page' />
        </div>
        <div style={{ width: '90%', maxWidth: '494px', textAlign: 'center', marginTop: '30px' }}>
          <p>Something went wrong, please try again later</p>
          <PrimaryButton
            value='Retry'
            backgroundColor='#B7D522'
            height='40px'
            width='188px'
            borderRadius='8px'
            padding='10px 16px'
            gap='10px'
            marginTop='30px'
            onClick={() => {
              window.location.href = '/';
            }}
          />
        </div>
      </div>
      <div style={{ maxWidth: '100%', height: 'auto', position: 'absolute', bottom: 0 }}>
        <img src={Ellipse75} />
      </div>
    </div>
  );
};

export default ErrorBoundarypage;
